import { useContext, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { axiosClient } from '../../../../library/Service/axiosClient';

const MembershipFees = () => {
    const { state } = useContext(SmartContext);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [status, setStatus] = useState('NOT_APPLICABLE');
    const [remarks, setRemarks] = useState('');

    const paymentStatuses = state?.domain?.get('MEMBERSHIP_FEE_PAYMENT_STATUS_CODE') || [];

    const studentId = id || null;

    const instituteId = useMemo(() => {
        const fromSelected = state?.data?.selectedInstitute?.instituteId;
        let fromLocal = null;
        try {
            const parsed = JSON.parse(localStorage.getItem('selectedInstitute') || '{}');
            fromLocal = parsed?.instituteId || null;
        } catch {
            fromLocal = null;
        }
        const fromUserInstitutes =
            state?.data?.userInstitutes?.find((x: any) => x?.instituteId)?.instituteId ||
            state?.data?.userInstitutes?.[1]?.instituteId;
        const user = sessionStorage.getItem('user');
        const parsedUser = user ? JSON.parse(user) : null;
        return fromSelected || fromLocal || parsedUser?.primaryInstitute || fromUserInstitutes || null;
    }, [state]);

    useEffect(() => {
        if (!studentId || !instituteId) return;
        setLoading(true);
        axiosClient()
            .post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/school-directory/membership-fee`, {
                student_id: studentId,
                institute_id: instituteId,
            })
            .then((res) => {
                if (res.data?.success) {
                    setStatus(res.data.data.membership_fee_payment_status_code || 'NOT_APPLICABLE');
                    setRemarks(res.data.data.membership_fee_remarks || '');
                }
            })
            .catch((e) => console.error('Error fetching membership fees', e))
            .finally(() => setLoading(false));
    }, [studentId, instituteId]);

    const onSave = async () => {
        if (saving || !studentId || !instituteId) return;
        setSaving(true);
        try {
            const res = await axiosClient().post(
                `${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/school-directory/membership-fee/update`,
                {
                    student_id: studentId,
                    institute_id: instituteId,
                    membership_fee_payment_status_code: status,
                    membership_fee_remarks: remarks,
                }
            );
            if (res.data?.success) {
                alert('Membership fees status updated successfully.');
            } else {
                alert(res.data?.message || 'Unable to update membership fees.');
            }
        } catch (e: any) {
            alert(e?.response?.data?.message || 'Something went wrong while saving.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div>
            <div className="font-18 font-600 mb-3">Membership Fees Payment Status</div>
            {loading && <div className="font-12 opacity-75 mb-3">Loading...</div>}
            <fieldset className="mb-4">
                {paymentStatuses.map((item: any) => (
                    <div key={item.code} className="form-check form-check-inline">
                        <input
                            id={`membership-fee-${item.code}`}
                            className="form-check-input rounded-circle"
                            type="radio"
                            name="membershipFeePaymentStatus"
                            value={item.code}
                            checked={status === item.code}
                            onChange={() => setStatus(item.code)}
                        />
                        <label className="form-check-label" htmlFor={`membership-fee-${item.code}`}>
                            {item.value}
                        </label>
                    </div>
                ))}
            </fieldset>
            <div className="mb-4">
                <label className="form-label" htmlFor="membership-fee-remarks">
                    Remarks
                </label>
                <textarea
                    id="membership-fee-remarks"
                    className="form-control"
                    rows={4}
                    maxLength={2000}
                    placeholder="Optional remarks"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                />
            </div>
            <button type="button" className="btn btn-green" disabled={saving || loading} onClick={onSave}>
                <span>{saving ? 'Saving...' : 'Save'}</span>
            </button>
        </div>
    );
};

export default MembershipFees;
